export default "__VITE_ASSET__DSnDSWVv__"